/* eslint-disable default-param-last */
import { Transformer, TRANSFORMERS } from '@lexical/markdown';
import { ElementNode } from 'lexical';
import createMarkdownExport from './MarkdownExports';

export default function $convertToMarkdownString(
  transformers: Array<Transformer> = TRANSFORMERS,
  node?: ElementNode,
  shouldPreserveNewLines: boolean = false,
): string {
  const exportMarkdown = createMarkdownExport(
    transformers,
    shouldPreserveNewLines,
  );
  return exportMarkdown(node);
}
